import { useContext, useState } from 'react'
import TemplateService, { Template } from '../services/templates-service'
import { ErrorContexts } from '../contexts/ErrorContext'
import * as uuid from 'uuid'

const voidTemplate: Template = {
  id: '',
  name: '',
  content: '',
  header: '',
  footer: '',
  headerHeight: '',
  footerHeight: '',
  format: 'A4',
  landscape: false
}

const useTemplate = () => {
  const { setError } = useContext(ErrorContexts)
  const [templates, setTemplates] = useState<Template[]>([])
  const [template, setTemplate] = useState<Template>(voidTemplate)

  const createTemplate = async (template: Template): Promise<Template> => {
    try {
      const id = uuid.v4()
      const newTemplate: Template = {
        ...template,
        id
      }
      await TemplateService.create(newTemplate)
      setTemplate(newTemplate)
      return newTemplate
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const fetchTemplates = async (): Promise<void> => {
    try {
      const templateList: Template[] = await TemplateService.list()
      setTemplates(templateList)
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const fetchTemplate = async (id: string): Promise<void> => {
    try {
      const template: Template = await TemplateService.getOne(id)
      setTemplate(template)
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const updateTemplate = async () => {
    try {
       await TemplateService.update(
        template.id,
        template
      )
    } catch (err) {
      setError(err)
      throw err
    }
  }

  const deleteTemplate = async (id: string): Promise<void> => {
    try {
      await TemplateService.delete(id)
      setTemplate(voidTemplate)
    } catch (err) {
      setError(err)
      throw err
    }
  }

  return {
    templates,
    template,
    setTemplate,
    setTemplates,
    fetchTemplates,
    fetchTemplate,
    deleteTemplate,
    createTemplate,
    updateTemplate
  }
}

export default useTemplate
